<template>
  <v-container>
    <v-row>
      <v-col :cols="12" :md="3" :offset-md="9">
        <v-text-field
          v-if="formattedItems.length > 5"
          append-icon="search"
          :label="$t('texts.search')"
          single-line
          hide-details
          v-model="search"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="formattedItems"
          :search="search"
          :no-data-text="$t('texts.application.noEntries')"
          :no-results-text="$t('texts.noSearchEntries')"
          class="elevation-0"
          :hide-default-footer="formattedItems.length < 5"
          :loading="fetchApplicationsPending"
        >
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              v-if="item.status === 'DRAFT'"
              color="info" top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  :to="{ name: 'employee.application.edit', params: { id: item.id }}"
                >
                  <v-icon color="primary">mode_edit</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('texts.edit') }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="item.status === 'DRAFT'"
              color="info" top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  @click="deleteItem(item)"
                >
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('texts.delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <confirmation-dialog ref="confirm"  :options="{ width: 500 }"/>
  </v-container>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import ConfirmationDialog from '@/components/_organisms/ConfirmationDialog.vue';

const { mapState: mapEmployeeState, mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');

export default {
  name: 'JobsDatatable',
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      search: '',
    };
  },
  created() {
    this.fetchApplications({
      listType: this.listType,
    });
  },
  computed: {
    ...mapEmployeeState([
      'fetchApplicationsPending',
      'jobApplications',
    ]),
    listType() {
      return this.$route.meta.listType;
    },
    headers() {
      const headers = [
        { text: this.$i18n.t('texts.workplace'), value: 'job', align: 'left' },
        { text: this.$i18n.t('texts.workload'), value: 'formattedJobWorkload', align: 'left' },
        { text: this.$i18n.t('texts.company.label'), value: 'company', align: 'left' },
        { text: this.$i18n.t('texts.place'), value: 'place', align: 'left' },
        { text: this.$i18n.t('texts.startOfWork'), value: 'formattedStartMonth', align: 'left' },
        { text: this.$i18n.t('texts.endOfWork'), value: 'formattedEndMonth', align: 'left' },
        { text: this.$i18n.t('texts.appliedForOn'), value: 'formattedApplicationSentDate', align: 'left' },
        { text: this.$i18n.t('texts.status'), value: 'formattedApplicationStatus', align: 'left' },
        { text: '', value: 'actions', align: 'right' },
      ];
      return headers;
    },
    formattedItems() {
      if (this.jobApplications[this.listType].length > 0) {
        return this.jobApplications[this.listType].map((item) => {
          const formattedJobWorkload = this.$options.filters.formatJobWorkload(item);
          const formattedStartMonth = this.$options.filters.formatDateMonth(`${item.start_year}-${item.start_month}-01`);
          const formattedEndMonth = this.$options.filters.formatDateMonth(`${item.end_year}-${item.end_month}-01`);
          const formattedApplicationSentDate = this.$options.filters.formatDateShort(item.application_sent);
          const formattedApplicationStatus = this.$i18n.t(`texts.applicationStatus.${item.status}`);
          const formattedItem = {
            ...item,
            formattedJobWorkload,
            formattedStartMonth,
            formattedEndMonth,
            formattedApplicationSentDate,
            formattedApplicationStatus,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    ...mapEmployeeActions([
      'fetchApplications',
      'deleteJobApplication',
    ]),
    async deleteItem(application) {
      const confirmDialog = async () => this.$refs.confirm.open({
        title: 'deleteJobApplication',
        message: 'actionCannotBeUndone',
        confirm: 'delete',
        reject: 'cancel',
      });
      if (await confirmDialog()) {
        this.deleteJobApplication(application);
      }
    },
  },
};
</script>
